import { FC } from 'react'

import { Flex, Spinner } from '@revolut-internal/ui-kit'

import { DEFAULT_LINE_CHART_HEIGHT } from 'modules/Monitoring/consts/chart'

type LineChartSkeletonProps = {
  height?: number
}

export const LineChartSkeleton: FC<LineChartSkeletonProps> = ({
  height = DEFAULT_LINE_CHART_HEIGHT,
}) => {
  return (
    <Flex height={height} justifyContent="center" alignItems="center">
      <Spinner color="grey-tone-20" size={24} />
    </Flex>
  )
}
